import entekhabFavicon from 'assets/html-pwa/Entekhab/favicon.ico';
import entekhabLogo180 from 'assets/html-pwa/Entekhab/180-type2.png';
import darsadFavicon from 'assets/html-pwa/Darsad/favicon.ico';
import darsadLogo180 from 'assets/html-pwa/Darsad/180.png';
import keepaFavicon from 'assets/html-pwa/Keepa/favicon.ico';
import keepaLogo180 from 'assets/html-pwa/Keepa/logo180.png';
import sabalendFavicon from 'assets/html-pwa/Sabalend/favicon.ico';
import sabalendLogo180 from 'assets/html-pwa/Sabalend/180.png';
import refahyarFavicon from 'assets/html-pwa/Refahyar/favicon.ico';
import refahyarLogo180 from 'assets/html-pwa/Refahyar/180.png';
import faraFavicon from 'assets/html-pwa/Fara/favicon.ico';
import faraLogo180 from 'assets/html-pwa/Fara/fara180x180.png';
import hamtalandFavicon from 'assets/html-pwa/Hamtaland/favicon.ico';
import hamtalandLogo180 from 'assets/html-pwa/Hamtaland/hamtaland - 180-min.png';
import rayansaipaFavicon from 'assets/html-pwa/Rayansaipa/favicon.ico';
import rayansaipaLogo180 from 'assets/html-pwa/Rayansaipa/180-180 (1).png';
import ghestaneFavicon from 'assets/html-pwa/Ghestane/favicon.ico';
import ghestaneLogo180 from 'assets/html-pwa/Ghestane/size176.jpg';
import tisaFavicon from 'assets/html-pwa/Tisa/favicon.ico';
import tisaLogo180 from 'assets/html-pwa/Tisa/176.png';

import saanaFavicon from 'assets/html-pwa/Saana/favicon.ico';
import saanaLogo180 from 'assets/html-pwa/Saana/176.png';

import shoppFavicon from 'assets/html-pwa/Shopp/favicon.ico';
import shoppLogo180 from 'assets/html-pwa/Shopp/176.png';

import arbaeenFavicon from 'assets/html-pwa/Arbaeen/favicon.ico';
import arbaeenLogo180 from 'assets/html-pwa/Arbaeen/176.png';

import DaneshFavicon from 'assets/html-pwa/Danesh/favicon.ico';
import DaneshLogo180 from 'assets/html-pwa/Danesh/danesh 176 176.png';

import KarmaFavicon from 'assets/html-pwa/Karma/favicon.ico';
import KarmaLogo180 from 'assets/html-pwa/Karma/176.png';

import hasteshFavicon from 'assets/html-pwa/Hastesh/favicon.ico';
import hasteshLogo180 from 'assets/html-pwa/Hastesh/176-176-min.png';

import armanpayFavicon from 'assets/html-pwa/Armanpay/favicon.ico';
import armanpay176 from 'assets/html-pwa/Armanpay/176.png';

import lendavidFavicon from 'assets/html-pwa/Lendavid/favicon.ico';
import lendavid176 from 'assets/html-pwa/Lendavid/176-176.png';

import FlyTodayFavicon from 'assets/html-pwa/Flytoday/favicon.ico';
import FlyToday176 from 'assets/html-pwa/Flytoday/176.png';

import CanFavicon from 'assets/html-pwa/Can/favicon.ico';
import Can176 from 'assets/html-pwa/Can/176x176.png';

import calkoFavicon from 'assets/html-pwa/Calko/favicon.ico';
import calko176 from 'assets/html-pwa/Calko/Calko176.png';

export const BRAND_CONFIGS = {
	hamtaland: {
		name: 'همتالند',
		title: 'همتالند',
		favicon: hamtalandFavicon,
		logo180: hamtalandLogo180,
		themeColor: '#ffffff',
		description: 'سرزمین خرید اعتباری',
	},
	fara: {
		name: 'Fara',
		title: 'فارا',
		favicon: faraFavicon,
		logo180: faraLogo180,
		themeColor: '#ffff',
	},
	darsad: {
		name: 'Darsad',
		title: 'اپلیکیشن کیف پول اعتباری - درصد',
		favicon: darsadFavicon,
		logo180: darsadLogo180,
		themeColor: '#e43024',
	},
	keepa: {
		name: 'Keepa',
		title: 'اپلیکیشن کیف پول اعتباری - کیپا',
		favicon: keepaFavicon,
		logo180: keepaLogo180,
		themeColor: '#35306f',
		description:
			'کیپا، کیف پول اعتباری شما برای خرید اقساطی از بیش از 5 هزار فروشگاه در کشور است. با کیپا می توانید به راحتی اقساطی خرید کنید، از اعتبار خود مطلع شوید و اقساط خود را مدیریت کنید.',
		url: 'https://pwa.keepa.ir',
	},
	sabalend: {
		name: 'Sabalend',
		title: 'اپلیکیشن کیف پول اعتباری - صبالند',
		favicon: sabalendFavicon,
		logo180: sabalendLogo180,
		themeColor: '#106239',
	},
	entekhab: {
		name: 'Entekhabino',
		title: 'اپلیکیشن کیف پول اعتباری - انتخابینو',
		favicon: entekhabFavicon,
		logo180: entekhabLogo180,
		themeColor: '#008F55',
		url: 'https://app.entekhabino.ir',
	},
	rayansaipa: {
		name: 'Rayan Saipa',
		title: 'لیزینگ رایان - سایپا',
		favicon: rayansaipaFavicon,
		logo180: rayansaipaLogo180,
		themeColor: '#ffff',
		description: 'سامانه برخط اعطای اعتبار و تسهیلات',
	},
	ghestane: {
		name: 'Ghestane',
		title: 'دریافت اعتبار بدون ضامن',
		favicon: ghestaneFavicon,
		logo180: ghestaneLogo180,
		themeColor: '#fa8071',
		description:
			'خرید قسطی بدون ضامن | قسطانه پلتفرم اعطای اعتبار از طریق راهکارهای مالی در قالب طرح های متنوع است',
	},
	refahyar: {
		name: 'Refah Yar',
		title: 'اپلیکیشن کیف پول اعتباری - رفاه یار',
		favicon: refahyarFavicon,
		logo180: refahyarLogo180,
		themeColor: '#106239',
	},
	tisa: {
		name: 'Tisa pay',
		title: 'تیسا پی؛ سامانه خرید و پرداخت اعتباری و اقساطی',
		favicon: tisaFavicon,
		logo180: tisaLogo180,
		themeColor: '#3D85C6',
		description:
			'تیسا پی سامانه خرید و اعطای اعتبار اقساطی از طریق راهکارهای نوین مالی در قالب طرح های متنوع',
	},
	saana: {
		name: 'Saana pay',
		title: 'بُن‌کارت رفاهی سانا',
		favicon: saanaFavicon,
		logo180: saanaLogo180,
		themeColor: '#3D85C6',
		description: 'خرید از فروشگاه‌های زنجیره‌ای',
	},
	shopp: {
		name: 'Shopp',
		title: 'شاپ',
		favicon: shoppFavicon,
		logo180: shoppLogo180,
		themeColor: '#3D85C6',
		description: 'شاپ اعتبار شگفت انگیز خرید شما!',
	},
	arbaeen: {
		name: 'اربعین',
		title: 'اربعین؛ سامانه خرید و پرداخت اعتباری و اقساطی',
		favicon: arbaeenFavicon,
		logo180: arbaeenLogo180,
		themeColor: '#3D85C6',
	},
	danesh: {
		name: 'Danesh pay',
		title: 'دانش، خرید اعتباری به دلخواه شما',
		favicon: DaneshFavicon,
		logo180: DaneshLogo180,
		themeColor: '#3D85C6',
		description:
			'دانش یک راه حل آسان و انعطاف‌پذیر برای خرید غیر نقدی است. این اپلیکیشن به شما امکان می‌دهد اکنون خرید کنید و هزینه آن را بعدا در چند قسط پرداخت کنید. ',
	},
	karma: {
		name: 'Karma',
		title: 'اپلیکیشن کارما',
		favicon: KarmaFavicon,
		logo180: KarmaLogo180,
		themeColor: '#2B3788',
		description: 'اپلیکیشن خرید اعتباری و بن کارت کارما',
	},
	hastesh: {
		name: 'Hastesh',
		title: 'هستش پی پلت فرم نوین وام دهی آنلاین',
		favicon: hasteshFavicon,
		logo180: hasteshLogo180,
		themeColor: '#a82682',
		description:
			'وام آنلاین، خرید اقساطی، تامین مالی سریع و آسان با هستش پی. بهترین شرایط وام، نرخ های رقابتی و فرآیند ساده برای وام های شخصی و تجاری . به اهداف مالی خود برسید',
	},
	armanpay: {
		name: 'Armanpay',
		title: 'آرمان پی',
		favicon: armanpayFavicon,
		logo180: armanpay176,
		themeColor: '#ffff',
		description: 'یک آتیه آرمانی',
	},
	calko: {
		name: 'Calko',
		title: 'اپلیکیشن کیف پول اعتباری کالکو',
		favicon: calkoFavicon,
		logo180: calko176,
		themeColor: '#ffff',
		description: 'خرید اعتباری از بیش از ۱۲۰۰۰ نقطه فروشگاهی در سراسر کشور',
	},
	lendavid: {
		name: 'Lendavid',
		title: 'لندآوید',
		favicon: lendavidFavicon,
		logo180: lendavid176,
		themeColor: '#F2F2CF',
		description: ' خرید امروز، پرداخت فردا',
	},
	flyToday: {
		name: 'ّFly Today',
		title: 'فلای‌تودی',
		favicon: FlyTodayFavicon,
		logo180: FlyToday176,
		themeColor: '#051e3c',
		description: '',
	},
	can: {
		name: 'ّCan Pay',
		title: 'کن پی',
		favicon: CanFavicon,
		logo180: Can176,
		themeColor: '#051e3c',
		description:
			'کن پی بستری برای خرید اعتباری است. شما می توانید بصورت آنلاین و حضوری از سایت لوازم خانگی کن، خرید و سپس بصورت اعتباری آن را بعدا و بدون کارمزد پرداخت کنید.',
	},
};

export const STARTUP_IMAGE_MEDIA_QUERIES = [
	'screen and (device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)',
	'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
	'screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)',
	'screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
	'screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
	'screen and (device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)',
	'screen and (device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
];

export const getBrandConfig = (brandFlags) => {
	if (brandFlags.isHamtaland) return BRAND_CONFIGS.hamtaland;
	if (brandFlags.isFara) return BRAND_CONFIGS.fara;
	if (brandFlags.isDarsad) return BRAND_CONFIGS.darsad;
	if (brandFlags.isKeepa || brandFlags.isDemo) return BRAND_CONFIGS.keepa;
	if (brandFlags.isSabahlend) return BRAND_CONFIGS.sabalend;
	if (brandFlags.isEntekhab) return BRAND_CONFIGS.entekhab;
	if (brandFlags.isRayansaipa) return BRAND_CONFIGS.rayansaipa;
	if (brandFlags.isGhestane) return BRAND_CONFIGS.ghestane;
	if (brandFlags.isTisa) return BRAND_CONFIGS.tisa;
	if (brandFlags.isSaana) return BRAND_CONFIGS.saana;
	if (brandFlags.isShopp) return BRAND_CONFIGS.shopp;
	if (brandFlags.isArbaeen) return BRAND_CONFIGS.arbaeen;
	if (brandFlags.isDanesh) return BRAND_CONFIGS.danesh;
	if (brandFlags.isKarma) return BRAND_CONFIGS.karma;
	if (brandFlags.isHastesh) return BRAND_CONFIGS.hastesh;
	if (brandFlags.isArmanPay) return BRAND_CONFIGS.armanpay;
	if (brandFlags.isCalko) return BRAND_CONFIGS.calko;
	if (brandFlags.isLendavid) return BRAND_CONFIGS.lendavid;
	if (brandFlags.isRefahYar) return BRAND_CONFIGS.refahyar;
	if (brandFlags.isFlyToday) return BRAND_CONFIGS.flyToday;
	if (brandFlags.isCan) return BRAND_CONFIGS.can;
};
